import * as React from 'react';
import { observer } from "mobx-react";
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import { AzureAuth, UserPermissions } from "@app/Classes/AzureAuth";
import { Layout } from '@app/Components/Layout/Layout';
import { Loading } from "@app/Components/Loading/Loading";

const HomePage = React.lazy(() => import('@pages/HomePage/HomePage'));
const RoomDetailsPage = React.lazy(() => import('@pages/RoomDetails/RoomDetailsPage'));
const HealthBoard = React.lazy(() => import('@pages/HealthBoard/HealthBoard'));
const JobList = React.lazy(() => import('@pages/Job/JobList'));
const ValidationRules = React.lazy(() => import('@pages/ValidationRulesPage/ValidationRulesPage'));
const MasterDataPage = React.lazy(() => import('@pages/MasterDataPage/MasterDataPage'));
const TemplatesManagement = React.lazy(() => import('@pages/TemplatesManagement/TemplatesManagement'));
const EmailViewer = React.lazy(() => import('@pages/EmailViewer/EmailViewer'));
const NotFound = React.lazy(() => import('@pages/NotFound/NotFound'));
const PermissionsTool = React.lazy(() => import('@pages/PermissionsTool/PermissionsTool'));
const Configs = React.lazy(() => import('@pages/Configs/Configs'));
const Guideline = React.lazy(() => import('@pages/Guideline/Guideline'));

export const AppRouter = observer(() => {
    const hasAccessToCases = AzureAuth.hasAccess([UserPermissions.InitiateProcess, UserPermissions.IrregularFlightsRead]);
    const hasAccessToAdminTools = AzureAuth.hasAccess(UserPermissions.AdminToolsRead);
    const hasAccessToAdminToolsWrite = AzureAuth.hasAccess(UserPermissions.AdminToolsWrite);
    const hasAccessToMasterData = AzureAuth.hasAccess(UserPermissions.MasterDataRead);
    const hasAccessToEmails = AzureAuth.hasAccess(UserPermissions.EmailsRead);
    const hasAccessToJobs = AzureAuth.hasAccess([UserPermissions.AdminToolsRead, UserPermissions.AdminToolsSafe]);
    
    return (
        <BrowserRouter>
            <Layout>
                <React.Suspense fallback={<Loading loading />}>
                    <Routes>
                        {hasAccessToCases && (
                            <Route path="/" element={<HomePage />}>
                                <Route path="case/:roomId/:includeRemoved" element={<RoomDetailsPage />} />
                            </Route>
                        )}
                        {hasAccessToAdminTools && <Route path="/health-board" element={<HealthBoard />} />}
                        {hasAccessToJobs && <Route path="/jobs" element={<JobList />} />}
                        {hasAccessToAdminTools && <Route path="/validation-rules" element={<ValidationRules />} />}
                        {hasAccessToAdminTools && <Route path="/permissions-tool" element={<PermissionsTool />} />}
                        {hasAccessToMasterData && <Route path="/master-data" element={<MasterDataPage />} />}
                        {hasAccessToMasterData && <Route path="/email-templates" element={<TemplatesManagement />} />}
                        {hasAccessToEmails && <Route path="/email-viewer" element={<EmailViewer />} />}
                        {hasAccessToAdminToolsWrite && <Route path="/configs" element={<Configs />} />}
                        <Route path="/guideline" element={<Guideline />} />
                        <Route path="*" element={<NotFound />} />
                    </Routes>
                </React.Suspense>
            </Layout>
        </BrowserRouter>
    );
});